import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { startWith } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators/map';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/shared/service/shared.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-map-selecion-popup',
  templateUrl: './map-selecion-popup.component.html',
  styleUrls: ['./map-selecion-popup.component.scss']
})
export class MapSelecionPopupComponent implements OnInit {
  filteredOptions: Observable<string[]>;
  factfilteredOptions: Observable<string[]>;
  linefilteredOptions: Observable<string[]>;
  lineUnderCluster;
  lineUnderFactory;
  reportGeneratorTitle;
  dialogRef: any;
  clusterList: any[] = [];
  factoryList: any[] = [];
  lineSelector: UntypedFormGroup;
  monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  min = new Date(2020, 0);
  max = new Date(new Date().getFullYear(), new Date().getMonth() - 1);

  public _filter(value: string): string[] {
    const filterValues = value.toLowerCase();
    return this.clusterList.filter(option => option.clusterId.toLowerCase().includes(filterValues));
  }

  public _filterfact(value: string): string[] {
    const filterValues = value.toLowerCase();
    return this.factoryList.filter(option => option.name.toLowerCase().includes(filterValues));
  }

  constructor(
    public formBuilder: UntypedFormBuilder,
    private sharedService: SharedService,
    private dialog: MatDialogRef<MapSelecionPopupComponent>) {
    this.lineSelector = this.formBuilder.group({
      cluster: ['', [Validators.required]],
      clusterid: ['', [Validators.required]],
      // factory: ['', [Validators.required]],
      // factoryid: ['', [Validators.required]],
      // period: ['', [Validators.required]],
      // displayPeriod: ['']
    });

    // this.lineSelector.controls.factory.disable();
    this.getCluster();
  }

  ngOnInit() { }

  onClusterChange(selectedCluster: any) {
    if (selectedCluster.id) {
      this.lineUnderCluster = selectedCluster;
      this.lineSelector.controls.clusterid.setValue(selectedCluster.id);
      // this.lineSelector.controls.factory.enable();
      // this.getFactoryList(selectedCluster);
      // this.lineSelector.controls.factory.setValue('');
      this.factoryList = selectedCluster.factoryList;
    }
  }

  onFactoryChange(selectedFactory: any) {
    if (selectedFactory.id) {
      this.lineUnderFactory = selectedFactory;
      // this.lineSelector.controls.factoryid.setValue(selectedFactory.id);
    }
  }

  getCluster() {
    this.clusterList = [];
    // getDFOSClusterList
    // getClusterList
    const clustersListResponse = JSON.parse(sessionStorage.getItem('dfos.userfactory.data'));
    if (clustersListResponse) {
      this.clusterList = clustersListResponse;
    }
    this.filteredOptions = this.lineSelector.controls.cluster.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  getFactoryList(selectedCluster: any) {
    this.factoryList = [];
    // getDFOSFactoryList
    // getTopFactoryList
    this.sharedService.getDFOSFactoryList(selectedCluster).subscribe(result => {
      this.factoryList = result;
      // this.factfilteredOptions = this.lineSelector.controls.factory.valueChanges
      //   .pipe(
      //     startWith(''),
      //     map(value => this._filterfact(value))
      //   );
    });
  }

  valueReset(catg: any) {
    if (catg === 'cluster') {
      this.lineSelector.controls.clusterid.reset();
      // this.lineSelector.controls.factory.disable();
    } else if (catg === 'factory') {
      // this.lineSelector.controls.factoryid.reset();
    }
  }

  dialogClose() {
    this.dialog.close('cancelled');
  }

  onSubmit() {
    if (JSON.parse(sessionStorage.getItem('spareCapacity'))) {
      const localStorageData = JSON.parse(sessionStorage.getItem('spareCapacity'));
      sessionStorage.setItem('spareCapacity',
        JSON.stringify({
          cluster: [this.lineUnderCluster],
          allClusters: localStorageData.allClusters,
          // factory: this.lineUnderFactory,
          // factory: this.factoryList,
          year: localStorageData.year,
          month: localStorageData.month,
          monthEPOC: localStorageData.monthEPOC
        })
      );
    }
    this.dialog.close('submitted');
  }
}
